// extracted by mini-css-extract-plugin
export default {"loaderComponent":"Loader_loaderComponent__VzIhK","showLoader":"Loader_showLoader__XKmYN","image-spin":"Loader_image-spin__NiZZ3"};